import SvgIcon from '@mui/material/SvgIcon';

export default function ReportIcon() {
  return (
    <SvgIcon
      sx={{
        fontSize: '2.5rem',
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="24" fill="#F4F4F4" />
        <path
          d="M16 16L32 32M32 16L16 32"
          stroke="#212121"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="24" cy="24" r="8" stroke="#212121" strokeWidth="2" />
        <path d="M24 12V16M24 32V36M12 24H16M32 24H36" stroke="#212121" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </SvgIcon>
  );
}
